import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import ChartFormatIndianNumber from "../../../Common/ChartFormatIndianNumber";
import NoDataFound from '../../NoDataFound/NoDataFound';
import useThemeTextColor from '../../../../../utils/useThemeTextColor';

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ChartDataLabels
);

const SalesVsSpendChart = ({ chartData = [] }) => {
  const textColor = useThemeTextColor();
  const borderColor = useThemeTextColor('--why-choose-card-border');

  if (!Array.isArray(chartData) || chartData.length === 0) {
    return <NoDataFound height={300} />;
  }

  const labels = chartData.map(item => item.period);
  const netSales = chartData.map(item => Number(item.net || 0));
  const actualNet = chartData.map(item => Number(item.actual_net || 0));
  const adsSpend = chartData.map(item => Number(item.spend || 0));

 const data = {
  labels,
  datasets: [
    {
      label: 'Net Sales',
      data: netSales,
      backgroundColor: '#90CAF9', // Soft Sky Blue
      barThickness: 20,
      borderRadius: 4
    },
    {
      label: 'Ads. Spend',
      data: adsSpend,
      backgroundColor: '#FFE082', // Light Orange
      barThickness: 20,
      borderRadius: 4
    },
  ]
};


  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false
    },
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
        color: textColor, 
        font: { size: 12 }
        }
      },
      datalabels: {
        display: false   // This disables all inline datalabels
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        callbacks: {
          label: context => {
            const value = context.parsed.y;
            return `${context.dataset.label}: ₹${value.toLocaleString('en-IN')}`;
          }
        }
      }
    },
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          font: { size: 12 },
          color: textColor
        },
        ticks: {
        color: textColor, // x-axis label color
        font: { size: 12 }
        },
        grid:{
          color:borderColor
        }
      },
      y: {
        stacked: true,
        beginAtZero: true,
        title: {
          display: true,
          font: { size: 12 },
            color: textColor
        },
        ticks: {
          callback: (value) => `₹${value.toLocaleString('en-IN')}`,
          color: textColor, // y-axis label color
          font: { size: 12 }
        },
          grid:{
            color:borderColor
          }
      }
    }
  };

  return (
    <div style={{ height: '360px' }}>
      <Bar data={data} options={options} plugins={[ChartDataLabels]} />
    </div>
  );
};

export default SalesVsSpendChart;
